import "./validation";
import { Fancybox } from "@fancyapps/ui/dist/fancybox/";
import Swiper from "swiper/bundle";
import Accordion from "accordion-js";

// const menuButton = document.getElementById("menu-button");
// const menu = document.getElementById("header-menu");
// let isMenuOpen = parseInt(menuButton.dataset.isMenuOpen);
// menuButton.addEventListener("click", function () {
// 	if (isMenuOpen) {
// 		menu.classList.remove("active");
// 		isMenuOpen = !isMenuOpen;
// 	} else {
// 		menu.classList.add("active");
// 		isMenuOpen = !isMenuOpen;
// 	}
// });
function returnSwiperSettings(swiperSectionSelector, swiperType) {
	switch (swiperType) {
		case "products":
			return {
				slidesPerView: 2,
				loop: false,
				spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
				breakpoints: {
					768: {
						slidesPerView: 4,
						loop: false,
						// spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
					},
				},
			};
		case "additional":
			return {
				slidesPerView: 1.2,
				loop: false,
				spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
				navigation: {
					enabled: false,
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						loop: false,
						// spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
						navigation: {
							enabled: true,
							prevEl: `${swiperSectionSelector} .slider-button_prev`,
							nextEl: `${swiperSectionSelector} .slider-button_next`,
						},
					},
				},
			};
		case "reviews":
			return {
				slidesPerView: 1,
				loop: false,
				spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
				scrollbar: {
					el: `${swiperSectionSelector} .swiper-scrollbar`,
					draggable: true,
					enabled: true,
					snapOnRelease: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						loop: false,
						// spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
						navigation: {
							prevEl: `${swiperSectionSelector} .slider-button_prev`,
							nextEl: `${swiperSectionSelector} .slider-button_next`,
						},
					},
				},
			};
		case "doctors":
		case "blogposts":
		default:
			return {
				slidesPerView: 1.2,
				loop: false,
				spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
				scrollbar: {
					el: `${swiperSectionSelector} .swiper-scrollbar`,
					draggable: true,
					enabled: true,
					snapOnRelease: true,
				},
				breakpoints: {
					768: {
						slidesPerView: 3,
						loop: false,
						// spaceBetween: `${calculateSwiperGapPx(10, 20)}px`,
						scrollbar: {
							enabled: false,
						},
					},
				},
			};
	}
}

function calculateSwiperGapPx(mobileGapPx, desktopGapPx) {
	const viewportWidthPx = window.innerWidth;

	const mobileViewportWidthPx = 480;
	const desktopViewportWidthPx = 1440;

	const minGapPx = Number(mobileGapPx);
	const maxGapPx = Number(desktopGapPx);

	if (!Number.isFinite(minGapPx) || !Number.isFinite(maxGapPx)) {
		return 0;
	}

	const progress =
		(viewportWidthPx - mobileViewportWidthPx) /
		(desktopViewportWidthPx - mobileViewportWidthPx);

	const clampedProgress = Math.min(1, Math.max(0, progress));

	console.debug(minGapPx + (maxGapPx - minGapPx) * clampedProgress);
	return minGapPx + (maxGapPx - minGapPx) * clampedProgress;
}

function initSwiper(swiperSectionSelector, swiperType) {
	let thisswiper = document.querySelector(`${swiperSectionSelector} .swiper`);
	if (thisswiper) {
		const swiper = new Swiper(
			thisswiper,
			returnSwiperSettings(swiperSectionSelector, swiperType),
		);
		allSwipers.push({ swiper, swiperType });
	} else {
		console.debug(swiperType, "Swiper container element not found!");
	}
}

const productCards = document.querySelectorAll(".product-card");
productCards.forEach((element, index) => {
	// element.classList.add(`slider-${index}`);
	// let swiperSectionSelector = `.slider-${index}`;
	// initSwiper(swiperSectionSelector, swiperType);
	new Swiper(element.querySelector(".swiper"), {
		slidesPerView: 1,
		speed: 300,
		// allowTouchMove: false,
		loop: true,
		effect: "fade",
		fadeEffect: {
			enabled: true,
			crossFade: true,
		},
		pagination: {
			el: element.querySelector(".swiper-pagination"),
			clickable: false,
		},
		navigation: {
			nextEl: element.querySelector(".swiper-button_next"),
			prevEl: element.querySelector(".swiper-button_prev"),
		},
	});

	// productCards.querySelectorAll('.swiper').forEach((swiperElement) => {

	// });
});

const allSwipers = [];
// const sliders = document.querySelectorAll(".section_swiper");
const sliders = document.querySelectorAll(".slider");

sliders.forEach((element, index) => {
	element.classList.add(`slider-${index}`);
	let swiperSectionSelector = `.slider-${index}`;
	let swiperType = element.dataset.swiperType;
	initSwiper(swiperSectionSelector, swiperType);
});

let lastBreakpoint = window.innerWidth >= 768;

function updateSwipers() {
	const currentBreakpoint = window.innerWidth >= 768;

	const gap = `${calculateSwiperGapPx(10, 20)}px`;

	allSwipers.forEach(({ swiper, swiperSectionSelector }) => {
		swiper.params.spaceBetween = gap;
		swiper.update();
	});

	lastBreakpoint = currentBreakpoint;
}

window.addEventListener("resize", updateSwipers);

if (document.querySelector(".accordion-root:not([data-accordion-type])")) {
	document
		.querySelectorAll(".accordion-root:not([data-accordion-type])")
		.forEach(function (element) {
			new Accordion(element, {
				duration: 250,
				elementClass: "accordion-item",
				triggerClass: "accordion-trigger",
				panelClass: "accordion-content",
				activeClass: "active",
				openOnInit: [0],
			});
		});
}

if (document.querySelector('.accordion-root[data-accordion-type="filters"]')) {
	const filterItems = new Accordion(document.querySelector('.accordion-root[data-accordion-type="filters"]'), {
		duration: 250,
		elementClass: "accordion-item",
		triggerClass: "accordion-trigger",
		panelClass: "accordion-content",
		activeClass: "active",
		showMultiple: true,
		openOnInit: [],
	});

	document.querySelector('.accordion-root[data-accordion-type="filters"]').querySelectorAll(".accordion-item").forEach((_, index) => {
		filterItems.open(index);
	});
}

const footerAccordionElement = document.querySelector('.accordion-root[data-accordion-type="footer"]');
let footerAccordion = null;
function updateFooterAccordion(event) {
	if (!footerAccordionElement) {
		return;
	}
	if (event.matches) {
		if (!footerAccordion) {
			footerAccordion = new Accordion(footerAccordionElement, {
				duration: 250,
				elementClass: "accordion-item",
				triggerClass: "accordion-trigger",
				panelClass: "accordion-content",
				activeClass: "active",
				showMultiple: true,
			});
		}
	} else {
		if (footerAccordion) {
			footerAccordion.destroy();
			footerAccordion = null;
		}
	}
}
const footerAccordionMediaQuery = window.matchMedia("(max-width: 767px)");
updateFooterAccordion(footerAccordionMediaQuery);
footerAccordionMediaQuery.addEventListener("change", updateFooterAccordion);

Fancybox.bind('[data-fancybox=""]', {
	dragToClose: false,
	closeButton: false,
	autoFocus: false,
	on: {
		"Carousel.ready Carousel.change": function () {
			// applying Imask within Fancybox
			const that = Fancybox.getSlide().el;
			const inputTel = that.querySelector(
				".input_tel:not([data-masked])",
			);
			if (inputTel) {
				IMask(inputTel, {
					mask: "+7 (000) 000-00-00",
					lazy: false,
				});
			}
			const inputEmail = that.querySelector(
				".input_email:not([data-masked])",
			);
			if (inputEmail) {
				IMask(inputEmail, {
					mask: "w@e.r",
					blocks: {
						w: { mask: /^[a-zA-Z0-9._%+-]+$/ },
						e: { mask: /^[a-zA-Z0-9.-]+$/ },
						r: { mask: /^[a-zA-Z]+$/ },
					},
					// mask:
				});
			}
		},
	},
});

document.querySelectorAll(".tabs").forEach((tabsRoot) => {
	const nav = tabsRoot.querySelector(".tabs__nav");
	const panels = Array.from(tabsRoot.querySelectorAll(".tabs__panel"));

	nav.addEventListener("click", (event) => {
		const trigger = event.target.closest(".tabs__trigger");
		if (!trigger) return;

		const targetKey = trigger.dataset.tab;

		nav.querySelectorAll(".tabs__trigger").forEach((btn) => {
			btn.classList.toggle("active", btn === trigger);
		});

		panels.forEach((panel) => {
			panel.classList.toggle("active", panel.dataset.tab === targetKey);
		});
	});
});

let productThumbsSlider;
const galleryThumbsElement = document.querySelector(".swiper.gallery-thumbs");
if (galleryThumbsElement) {
	const slidesPerView = parseInt(galleryThumbsElement.dataset.slidesPerView, 10) === 3 ? 3 : 4;
	productThumbsSlider = new Swiper(galleryThumbsElement, {
		slidesPerView,
		loop: false,
		spaceBetween: `${calculateSwiperGapPx(8, 10)}px`,
	});
}

const productSlider = new Swiper(".swiper.gallery-main", {
	slidesPerView: 1,
	loop: false,
	thumbs: {
		swiper: productThumbsSlider ?? "null",
	},
	navigation: {
		nextEl: ".gallery-main__slider-arrow_next",
		prevEl: ".gallery-main__slider-arrow_prev",
	},
	pagination: {
		el: ".gallery-main__slider-dots",
		type: "bullets",
	},
	effect: "fade",
	fadeEffect: {
		crossFade: true,
	},
});

const categoriesSlider = new Swiper(".categories-slider-wrapper", {
	slidesPerView: "auto",
	loop: false,
	spaceBetween: `${calculateSwiperGapPx(8, 10)}px`,
	freeMode: true,
});

let branchesSwiper = null;

function updateBranchesSwiper() {
	const shouldEnable = window.innerWidth < 768;

	if (shouldEnable && !branchesSwiper) {
		branchesSwiper = new Swiper(".map .swiper.swiper_map", {
			slidesPerView: 1.2,
			loop: false,
			spaceBetween: `${calculateSwiperGapPx(10, 10)}px`,
		});
	}

	if (!shouldEnable && branchesSwiper) {
		branchesSwiper.destroy(true, true);
		branchesSwiper = null;
	}
}

updateBranchesSwiper();

window.addEventListener("resize", updateBranchesSwiper);
